import { ActionTree }                                         from 'vuex';
import { RootState }                                          from '@/store/store.types';
import i18n                                                   from '@/i18n';
import { Notification }                                       from '@/components/notification/notification';
import { getCalendarConfiguration, putCalendarConfiguration } from '@/views/calendar-configuration/services/calendar-configuration.service';
import { CalendarConfigurationConfig, State }                 from '@/views/calendar-configuration/calendar-configuration.types';

const actions: ActionTree<State, RootState> = {
  async getCalendarConfiguration({ commit }): Promise<void> {
    try {
      commit('setConfigurationLoading', true);
      const { data }: { data: CalendarConfigurationConfig } = await getCalendarConfiguration();
      commit('setCalendarConfiguration', data);
    } catch (e) {
      Notification.error(
        i18n.t('vCalendarConfiguration.notification.error.title') as string,
        i18n.t('vCalendarConfiguration.notification.error.getConfiguration') as string,
      );
      throw e;
    } finally {
      commit('setConfigurationLoading', false);
    }
  },
  async putCalendarConfiguration({ commit }, payload: CalendarConfigurationConfig): Promise<void> {
    try {
      commit('setConfigurationLoading', true);
      const { data }: { data: CalendarConfigurationConfig } = await putCalendarConfiguration(payload);
      commit('setCalendarConfiguration', data);
      Notification.success(
        i18n.t('vCalendarConfiguration.notification.success.title') as string,
        i18n.t('vCalendarConfiguration.notification.success.updateConfiguration') as string,
      );
    } catch (e) {
      Notification.error(
        i18n.t('vCalendarConfiguration.notification.error.title') as string,
        i18n.t('vCalendarConfiguration.notification.error.updateConfiguration') as string,
      );
      throw e;
    } finally {
      commit('setConfigurationLoading', false);
    }
  },
};

export default actions;
